var map = {
	"./AddQualificationModal/AddQualificationModal": 206,
	"./AddQualificationModal/AddQualificationModal.jsx": 206,
	"./AddQualificationModal/Main": 904,
	"./AddQualificationModal/Main.jsx": 904,
	"./AdminHomepage/HeroTest": 906,
	"./AdminHomepage/HeroTest.jsx": 906,
	"./AdminHomepage/Main": 907,
	"./AdminHomepage/Main.jsx": 907,
	"./AdminHomepage/MainContent": 207,
	"./AdminHomepage/MainContent.jsx": 207,
	"./AdminHomepage/Sidebar": 214,
	"./AdminHomepage/Sidebar.jsx": 214,
	"./AvatarUploaderForm/Main": 1459,
	"./AvatarUploaderForm/Main.jsx": 1459,
	"./ChannelDesign/Home": 263,
	"./ChannelDesign/Home.jsx": 263,
	"./ChannelDesign/HomepageSettings": 216,
	"./ChannelDesign/HomepageSettings.jsx": 216,
	"./Discussions/HomepageContainer": 908,
	"./Discussions/HomepageContainer.jsx": 908,
	"./Home/ArticleCard": 80,
	"./Home/ArticleCard.jsx": 80,
	"./Home/CureusUCard": 82,
	"./Home/CureusUCard.jsx": 82,
	"./Home/CureusUpdates": 215,
	"./Home/CureusUpdates.jsx": 215,
	"./Home/CureusUpdatesHistoryTable": 910,
	"./Home/CureusUpdatesHistoryTable.jsx": 910,
	"./Home/FeaturedContent": 211,
	"./Home/FeaturedContent.jsx": 211,
	"./Home/FeaturedContentCard": 212,
	"./Home/FeaturedContentCard.jsx": 212,
	"./Home/FeaturedContentCarousel": 911,
	"./Home/FeaturedContentCarousel.jsx": 911,
	"./Home/FeaturedContentModal": 213,
	"./Home/FeaturedContentModal.jsx": 213,
	"./Home/MetricsCard": 79,
	"./Home/MetricsCard.jsx": 79,
	"./Home/NewsCard": 81,
	"./Home/NewsCard.jsx": 81,
	"./Home/Search": 912,
	"./Home/Search.jsx": 912,
	"./Home/VideoImage": 913,
	"./Home/VideoImage.jsx": 913,
	"./Home/VideoModal": 217,
	"./Home/VideoModal.jsx": 217,
	"./HomepageFeaturedArticles/Card": 346,
	"./HomepageFeaturedArticles/Card.jsx": 346,
	"./HomepageFeaturedArticles/Content": 218,
	"./HomepageFeaturedArticles/Content.jsx": 218,
	"./HomepageFeaturedArticles/Main": 914,
	"./HomepageFeaturedArticles/Main.jsx": 914,
	"./HomepageHeros": 915,
	"./HomepageHeros.js": 915,
	"./HomepageHeros/DeleteHeroModal": 210,
	"./HomepageHeros/DeleteHeroModal.jsx": 210,
	"./HomepageHeros/Hero": 209,
	"./HomepageHeros/Hero.jsx": 209,
	"./HomepageHeros/Main": 208,
	"./HomepageHeros/Main.jsx": 208,
	"./NewReviewsDashboard/DashboardKeywordTool": 160,
	"./NewReviewsDashboard/DashboardKeywordTool.jsx": 160,
	"./NewReviewsDashboard/InfoWidget": 238,
	"./NewReviewsDashboard/InfoWidget.jsx": 238,
	"./NewReviewsDashboard/KeywordAutoSuggester": 440,
	"./NewReviewsDashboard/KeywordAutoSuggester.jsx": 440,
	"./NewReviewsDashboard/Main": 1474,
	"./NewReviewsDashboard/Main.jsx": 1474,
	"./NewReviewsDashboard/Reviewership": 441,
	"./NewReviewsDashboard/Reviewership.jsx": 441,
	"./NotificationsCenter/ApprovalEditorOneMatchModal": 138,
	"./NotificationsCenter/ApprovalEditorOneMatchModal.jsx": 138,
	"./NotificationsCenter/ApprovalEditorResubmittedModal": 139,
	"./NotificationsCenter/ApprovalEditorResubmittedModal.jsx": 139,
	"./NotificationsCenter/ChannelAdminReviewArticlesModal": 140,
	"./NotificationsCenter/ChannelAdminReviewArticlesModal.jsx": 140,
	"./NotificationsCenter/CollectionApplicationApprovalModal": 141,
	"./NotificationsCenter/CollectionApplicationApprovalModal.jsx": 141,
	"./NotificationsCenter/GuestEditorModal": 142,
	"./NotificationsCenter/GuestEditorModal.jsx": 142,
	"./NotificationsCenter/Main": 143,
	"./NotificationsCenter/Main.jsx": 143,
	"./NotificationsCenter/ReviewerModal": 144,
	"./NotificationsCenter/ReviewerModal.jsx": 144,
	"./PicturePrognosisHome/AnswerBarRow": 103,
	"./PicturePrognosisHome/AnswerBarRow.jsx": 103,
	"./PicturePrognosisHome/AnswerOption": 219,
	"./PicturePrognosisHome/AnswerOption.jsx": 219,
	"./PicturePrognosisHome/AnswerOutcome": 220,
	"./PicturePrognosisHome/AnswerOutcome.jsx": 220,
	"./PicturePrognosisHome/Clarification": 221,
	"./PicturePrognosisHome/Clarification.jsx": 221,
	"./PicturePrognosisHome/Landing": 916,
	"./PicturePrognosisHome/Landing.jsx": 916,
	"./PicturePrognosisHome/Widget": 264,
	"./PicturePrognosisHome/Widget.jsx": 264,
	"./UserProfile": 1481,
	"./UserProfile.js": 1481,
	"./UserProfile/Biography": 1482,
	"./UserProfile/Biography.jsx": 1482,
	"./UserProfile/ContentCard": 265,
	"./UserProfile/ContentCard.jsx": 265,
	"./UserProfile/Main": 1483,
	"./UserProfile/Main.jsx": 1483,
	"./UserProfile/SiqHover": 1484,
	"./UserProfile/SiqHover.jsx": 1484,
	"./UserProfileModals": 1485,
	"./UserProfileModals.js": 1485,
	"./UserProfileModals/AffiliationsMain": 446,
	"./UserProfileModals/AffiliationsMain.jsx": 446,
	"./UserProfileModals/AffiliationsRow": 447,
	"./UserProfileModals/AffiliationsRow.jsx": 447,
	"./UserProfileModals/EditAboutMe": 448,
	"./UserProfileModals/EditAboutMe.jsx": 448,
	"./UserProfileModals/EditInstitutionalEmail": 449,
	"./UserProfileModals/EditInstitutionalEmail.jsx": 449,
	"./UserProfileModals/EditProfile": 450,
	"./UserProfileModals/EditProfile.jsx": 450,
	"./UserProfileModals/Main": 1486,
	"./UserProfileModals/Main.jsx": 1486,
	"./UserProfileModals/Npi": 452,
	"./UserProfileModals/Npi.jsx": 452,
	"./UserProfileModals/NpiEdit": 453,
	"./UserProfileModals/NpiEdit.jsx": 453,
	"./UserProfileModals/NpiOther": 454,
	"./UserProfileModals/NpiOther.jsx": 454,
	"./UserProfileModals/NpiRegistered": 456,
	"./UserProfileModals/NpiRegistered.jsx": 456,
	"./UserProfileModals/NpiRows": 200,
	"./UserProfileModals/NpiRows.jsx": 200,
	"./UserProfileModals/NpiUs": 455,
	"./UserProfileModals/NpiUs.jsx": 455,
	"./UserProfileModals/PeerReviewPanel": 457,
	"./UserProfileModals/PeerReviewPanel.jsx": 457,
	"./UserProfileModals/PhoneNumber": 451,
	"./UserProfileModals/PhoneNumber.jsx": 451,
	"./UserProfileModals/PublicProfile": 458,
	"./UserProfileModals/PublicProfile.jsx": 458,
	"./UsersPage/Activities": 1487,
	"./UsersPage/Activities.jsx": 1487,
	"./UsersPage/Coauthors": 1488,
	"./UsersPage/Coauthors.jsx": 1488
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2166;